import "./assets/scss/themes.scss";
import RouteIndex from "Routes/Index";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
    <ToastContainer/>
    <RouteIndex />;
    </>
  )
}

export default App;
